import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserNamespace} from '@namespaces/user.namespace';
import {AuthService} from '@services/auth.service';

/**
 * Стркутурная директива проверки прав доступа к элементу
 */
@Directive({
    selector: '[checkAccess]'
})
export class CheckAccessDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authService: AuthService,
    ) {
    }

    @Input() set checkAccess(permissions: UserNamespace.Permission[]) {
        if (permissions && permissions.length && this.authService.hasPermissions(permissions)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
